import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
@Injectable()
export class RoleGuard implements CanActivate {

    constructor(private router: Router, private afs: AngularFirestore) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const permission = route.data['permission'];
        try {
            return this.afs.collection('adminUsers').doc(localStorage.getItem('currentUserId')).ref.get().then(data => {
                if (data.exists) {
                    const onActivate = permission.only.includes(data.data().roles);
                    console.log(onActivate)
                    if (onActivate) {
                        return true;
                    }
                    else {
                        this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
                        return false;

                    }


                }
                else {
                    this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
                }
                this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
                return false;
            });



        }
        catch (e) {
            this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });


        }

    }

}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/_guards/role.guard.ts